import { memo } from 'react'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import illustration from './assets/illustration@2x.png'

const BannerContainer = styled('div')<{ clickable?: boolean }>(
  ({ theme, clickable }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2, 2),
    borderRadius: 0,
    background: 'linear-gradient(270deg, #1B5426 0%, #277634 100%)',
    color: '#fff',
    overflow: 'hidden',
    minHeight: 80,
    cursor: clickable ? 'pointer' : 'default'
  })
)

const Illustration = styled('img')(({}) => ({
  position: 'absolute',
  right: -10,
  bottom: -15,
  height: '155%',
  pointerEvents: 'none'
}))

const Title = styled(Typography)({
  fontWeight: 900,
  fontSize: '28px',
  color: '#fff',
  textAlign: 'left',
  lineHeight: '28px'
})

const Subtitle = styled(Typography)({
  fontWeight: 400,
  fontSize: '28px',
  lineHeight: 'normal',
  color: '#fff',
  textAlign: 'left'
})

const TextContent = styled('div')(({ theme }) => ({
  zIndex: 1,
  width: '100%',
  textAlign: 'left',
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 532,
    margin: '0 auto'
  }
}))

interface TopBannerProps {
  title: string
  subtitle?: string
  onClick?: () => void
}

const TopBanner = ({ title, subtitle, onClick }: TopBannerProps) => (
  <BannerContainer clickable={!!onClick} onClick={onClick}>
    <TextContent>
      <Illustration src={illustration} alt="" aria-hidden="true" />
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </TextContent>
  </BannerContainer>
)

export default memo(TopBanner)
